import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-si-glyph-layout-1",
  "use": "icon-si-glyph-layout-1-usage",
  "viewBox": "0 0 17 16",
  "content": "<symbol viewBox=\"0 0 17 16\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" class=\"si-glyph si-glyph-layout-1\" id=\"icon-si-glyph-layout-1\"><title>1207</title><defs></defs><g stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\"><g transform=\"translate(1.000000, 0.000000)\" fill=\"#434343\"><path d=\"M16,16 L1.13686838e-13,16 L1.13686838e-13,0 L16,0 L16,16 L16,16 Z M1,15 L15,15 L15,1 L1,1 L1,15 L1,15 Z\" class=\"si-glyph-fill\" /><rect x=\"2\" y=\"2\" width=\"6\" height=\"12\" class=\"si-glyph-fill\" /><rect x=\"9\" y=\"2\" width=\"5\" height=\"6\" class=\"si-glyph-fill\" /><rect x=\"9\" y=\"9\" width=\"5\" height=\"5\" class=\"si-glyph-fill\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/glyph/si-glyph-layout-1.svg
// module id = PBQO
// module chunks = 62